import {
  ClassDetailsNoSectionsQuery,
  ListingsByActivityUidsQuery as ListingsByActivityUidsQueryType,
  ListingsByActivityUidsQueryVariables,
} from "@outschool/gql-frontend-generated";
import { useQueryWithPreviousData } from "@outschool/ui-apollo";

import * as ClassPageVisitHistory from "../../ClassPageVisitHistory";
import ListingsByActivityUidsQuery from "../graphql/ListingsByActivityUidsQuery";

const getPageVisitHistoryList = ({
  currentActivityUid,
}: {
  currentActivityUid?: string;
} = {}) => {
  const list = ClassPageVisitHistory.getList()
    .filter(item => item.activityUid !== currentActivityUid)
    .slice(0, 20)
    .map(x => x.activityUid);

  return list;
};

export const usePageVisitHistoryList = (
  currentActivity?: ClassDetailsNoSectionsQuery["activity"],
) => {
  const list = getPageVisitHistoryList({
    currentActivityUid: currentActivity?.uid,
  });

  const { data } = useQueryWithPreviousData<
    ListingsByActivityUidsQueryType,
    ListingsByActivityUidsQueryVariables
  >(ListingsByActivityUidsQuery, {
    skip: !list || !list.length,
    variables: {
      activityUids: list,
      skipRating: false,
      withRecentReviews: false,
    },
  });

  return data?.listingsByActivityUids;
};
